import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Initial page view is tracked by the inline Whop snippet in index.html.
export const WhopPageTracker = () => {
  const { pathname } = useLocation();
  const last = useRef(pathname);

  useEffect(() => {
    if (pathname === last.current) return;
    last.current = pathname;
    window.whop && window.whop.track("page");
  }, [pathname]);

  return null;
};
